export default __webpack_public_path__ + "static/media/army_121.6ac5fc84.jpg";